
import { LiaShippingFastSolid } from "react-icons/lia";
import { MdRotateLeft } from "react-icons/md";
import { CiCreditCard2 } from "react-icons/ci";
import { FaInstagram } from "react-icons/fa6";
import { FiFacebook } from "react-icons/fi";
import { RiTwitterXLine } from "react-icons/ri";
import { Link } from "react-router-dom";


 const Collabs = () => {

  return (
 
      <section className="mt-[-20%] sm:mt-[-10%] md:mt-0">
        <div className=" my-3 ">
         
          <div>
          <div className="grid md:grid-cols-2  grid-cols-1 lg:grid-cols-4 p-4 rounded-xl bg-white ">
              <div className="text-start px-4 ">
                <div className="flex justify-start my-3">
                <LiaShippingFastSolid className="text-3xl text-start" />
                </div>
                <p className="text-black  text-xl ">Fast , Free Shipping</p>
                <p className="text-gray-500 text-[13px] h-[100px] ">
                  Orders over $75 ship for free. Or sign up for a Converse.com
                  account and get free shipping on every order.
                  <br></br>
                  <Link to="https://conversehelp.force.com/s/article/what-are-converse-com-s-shipping-options" className="text-[14px] font-bold mb-4 underline">Learn More</Link>

                </p>
              </div>
              <div className="text-start px-4 ">
                <div className="flex justify-start my-3">
                  <MdRotateLeft className="text-3xl text-start" />
                </div>
                <p className="text-black  text-xl  ">Worry-Free Returns</p>
                <p className="text-gray-500 text-[13px] h-[100px] ">
                  Not happy? Return or exchange your purchase for free within 30
                  days.
                  <br></br>                
                  <Link to="https://conversehelp.force.com/s/topic/0TO1N0000019UpZWAU/returns-exchanges" className="text-[14px] font-bold underline">Learn More</Link>
                </p>
              </div>
              <div className="text-start px-4 ">
                <div className="flex justify-start my-3">
                  <CiCreditCard2 className="text-3xl text-center" />
                </div>

                <p className="text-black  text-xl  ">Converse Gift Cards</p>
                <p className="text-gray-500  text-[13px] h-[100px] ">
                  Give them exactly what they want with a Converse Gift Card.{" "}
                 <br></br> <Link to="https://www.converse.com/c/gift-cards" className="text-[14px] font-bold underline">Learn More</Link>
                </p>
               
              </div>
              <div className="text-start px-4 ">
                <div className="flex justify-start my-3">
                  <FiFacebook className="text-xl text-start" />
                   <FaInstagram className="text-xl text-center mx-3" />
                  <RiTwitterXLine className="text-xl text-center" />
                </div>
                <p className="text-black  text-xl ">Follow Us</p>
                <p className="text-gray-500  text-[13px] h-[100px] ">
                  Keep up with the latest Converse news on our social channels.{" "}
                </p>
              </div>
            </div>
          </div>
        </div>

      </section>

  );
};

export default Collabs;